module.exports = __webpack_public_path__ + "static/Buy on SOLV video-47db278e6975b423efc5bb6c0edc014b.mp4";